import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M4.594 14.422C3.172 12.645 0 8.406 0 6A5.234 5.234 0 0 1 5.25.75 5.25 5.25 0 0 1 10.5 6c0 2.406-3.2 6.645-4.621 8.422a.825.825 0 0 1-1.285 0M5.25 7.75C6.207 7.75 7 6.984 7 6c0-.957-.793-1.75-1.75-1.75-.984 0-1.75.793-1.75 1.75 0 .984.766 1.75 1.75 1.75"
    }, null, -1)
  ])))
}
export default { render: render }